module.exports = __webpack_public_path__ + "img/00012.a9efff60.webp";